export default "__VITE_ASSET__4120e752__"